import React from 'react';
import Heading from '../../../components/typography';
import { ProfilePic } from './profile.styled';
import ProfilePicImage from '../../../assets/images/profilepic.png';
import { useAdvanceBoolean, useGetProfileImage, usePostCompanyProfileLogo } from '../../../hooks';
import useDeleteCompanyProfileLogo from '../../../hooks/delete/useDeleteCompanyProfileLogo';
import AlertPopup from '../../../components/alert-popup';

interface ProfileUploadType {
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>;
  id?: string;
}

const ProfileUpload = ({ handleRequest, id }: ProfileUploadType): JSX.Element => {
  const { data: ProfileImage } = useGetProfileImage(handleRequest);
  const { mutate } = usePostCompanyProfileLogo(handleRequest);

  const {
    value: isConfirmOpen,
    setFalse: closeConfirmModal,
    setTrue: openConfirmModal,
  } = useAdvanceBoolean<string>(false);

  const { mutate: deleteCompanyLogo, isLoading: isDeleting } = useDeleteCompanyProfileLogo(
    handleRequest,
    closeConfirmModal
  );

  const handleProfileChange = (e: any): void => {
    const payload = {
      CompanyLogo: e.target.files[0],
    };

    mutate(payload);
  };

  return (
    <div id="profileUploadContainer">
      <ProfilePic id="profilePic">
        <label className='' role='button' id="profilePicChangeLabel">
          <span className='material-symbols-outlined icon' id="profilePicChangeIcon">add_a_photo</span>
          <Heading variant='body-xs' title='Change' className='profilePicText' id="profilePicChangeText" />
          <input type='file' accept='.jpg, .png, .jpeg' onChange={handleProfileChange} id="profilePicFileInput" />
        </label>
        {ProfileImage?.content && (
          <label className='delete-icon' role='button' onClick={() => openConfirmModal()} id="profilePicDeleteLabel">
            <span className='material-symbols-outlined icon' id="profilePicDeleteIcon">delete</span>
          </label>
        )}

        {(ProfileImage?.content as unknown as boolean) ? (
          <img
            src={`data:image/png;base64,${ProfileImage?.content ?? ''}`}
            alt={`${ProfileImage?.name ?? ''}`}
            id="profilePicImage"
          />
        ) : (
          <img src={ProfilePicImage} alt='User Profile' id="profilePicDefaultImage" />
        )}
      </ProfilePic>
      {isConfirmOpen && (
        <AlertPopup
          isShow={isConfirmOpen}
          closeModal={closeConfirmModal}
          customTitle={`Are you sure to remove the Company Logo?`}
          handleSubmit={() => deleteCompanyLogo()}
          loading={isDeleting}
          id="profilePicDeleteConfirmationModal"
        />
      )}
    </div>
  );
};

export default ProfileUpload;
